import QuestionGroupIcon from '@material-ui/icons/ViewList';

import QuestionGroupList from './QuestionGroupList';
import QuestionGroupCreate from './QuestionGroupCreate';
import QuestionGroupEdit from './QuestionGroupEdit';

export default {
  list: QuestionGroupList,
  create: QuestionGroupCreate,
  edit: QuestionGroupEdit,
  icon: QuestionGroupIcon,
};
